/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import {FiraSansBold} from 'components/Text';
import {mediaHelper} from "../../utils/src";
import Colors from 'constants/Colors';


export const Container = styled.div`
  background-color: ${Colors.GREEN};
  margin-top: 10px;
  margin-bottom: 10px;
  border: 2px solid ${Colors.GREEN};
  border-radius: 10px;
  width: 100%;
  
  ${mediaHelper.sm`
    border-radius: 15px;
  `}
  
  ${mediaHelper.md`
    border-radius: 20px;
  `}
`;

export const CardHeader = styled.div`
  display: flex;
  color:#FFF;
  justify-content: space-between;
  text-transform: uppercase;
  font-weight:${FiraSansBold};
  font-family:'Fira Sans', sans-serif;
  cursor: pointer;
  
  padding: 5px 10px;
  font-size: 14px;
  
  ${mediaHelper.sm`
    padding: 10px 15px;
    font-size: 18px;
  `}
  
  .icon-arrowup-white {
    width: 20px;
    height: 20px;
    min-width: 20px;
    transition: transform ease-in-out 200ms;
    
    &:before{
      background-size: 100%
      width: 80%;
      height: 80%;
      margin: 10%;
    }
    
    &.closed {
      transform: rotate(180deg);
    }
  }
`;

export const CardContent = styled.div.attrs(( {
  minHeight
}) => ({
  minHeight
}))`
  background-color: #FFF;
  color: #000;
  
  flex-grow: 1;
  border-radius: 0px 0px 10px 10px;
  overflow: hidden;
  max-height: 0px;
  transition: all ease-in-out 500ms;
  
  ${mediaHelper.sm`
    border-radius: 0px 0px 15px 15px;
  `}
  
  ${mediaHelper.md`
    border-radius: 0px 0px 20px 20px;
  `}
  
  &.expanding {
    max-height: 2500px;
  }
  
  &.collapsing {
    max-height: 0;
  }
  
  &.expanded {
    max-height: unset;
    overflow: initial;
    min-height: ${props => props.minHeight || "unset"}
  }

  &.before-collapsing { 
    max-height: 2500px;
  }
`;

export const Expandable = styled.div`
  padding: 5px;
  
  ${mediaHelper.sm`
    padding: 10px;
  `}
`;